import { Link } from "react-router-dom";
import { Truck, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A2F24] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-[#E68A00] rounded-md flex items-center justify-center">
                <Truck className="w-6 h-6 text-white" />
              </div>
              <span className="text-2xl font-bold" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Creek Bottom <span className="text-[#E68A00]">Rentals</span>
              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mt-3">
              Family-owned equipment rental business in the Piney Woods of East Texas. Serving our community with reliable tools and honest service from our ranch and RV park.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Quick Links
            </h4>
            <div className="space-y-2">
              <Link to="/equipment" className="block text-sm text-white/70 hover:text-[#E68A00] transition-colors">
                Browse Equipment
              </Link>
              <Link to="/#about" className="block text-sm text-white/70 hover:text-[#E68A00] transition-colors">
                Our Story
              </Link>
              <Link to="/login" className="block text-sm text-white/70 hover:text-[#E68A00] transition-colors">
                Customer Login
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Contact Us
            </h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-sm text-white/70">
                <Phone className="w-4 h-4 text-[#E68A00] flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:+18327140101" className="block hover:text-[#E68A00] transition-colors">Mr. Dallas (832) 714-0101</a>
                  <a href="tel:+12817234017" className="block hover:text-[#E68A00] transition-colors mt-1">Mrs. Keara (281) 723-4017</a>
                </div>
              </div>
              <div className="flex items-center gap-3 text-sm text-white/70">
                <Mail className="w-4 h-4 text-[#E68A00] flex-shrink-0" />
                <span>info@creekbottomrentals.com</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-white/70">
                <MapPin className="w-4 h-4 text-[#E68A00] flex-shrink-0 mt-0.5" />
                <div>
                  <span>2724 Private Road 8160</span><br />
                  <span>Lovelady, TX 75851</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Google Maps */}
        <div className="mt-12 rounded-lg overflow-hidden border border-white/10">
          <iframe
            data-testid="google-map"
            title="Creek Bottom Rentals Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000!2d-95.45!3d31.13!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzHCsDA3JzQ4LjAiTiA5NcKwMjcnMDAuMCJX!5e0!3m2!1sen!2sus!4v1700000000000&q=2724+Private+Road+8160+Lovelady+TX+75851"
            width="100%"
            height="250"
            style={{ border: 0, filter: "grayscale(30%) contrast(1.1)" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-sm text-white/40">
            &copy; {new Date().getFullYear()} Creek Bottom Rentals. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
